export const isTouchPad = (e: WheelEvent) => {
  // https://stackoverflow.com/questions/10744645/detect-touchpad-vs-mouse-in-javascript
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { wheelDeltaY, deltaY, deltaMode } = e as any;
  return wheelDeltaY ? wheelDeltaY === -3 * deltaY : deltaMode === 0;
};

export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const isMac = () => {
  return navigator.userAgent.indexOf('Mac OS X') !== -1;
};

export const isDev = () => {
  return process.env.NODE_ENV === 'development';
};

export const isObject = (value: unknown): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};
